import { useEffect } from "react";

function NumberButton({ num, onClick }) {
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === String(num)) {
        onClick(num);
      }
    };
    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [num, onClick]);

  return <button onClick={() => onClick(num)} className="btn btn-block btn-primary">{num}</button>;
}

export default NumberButton;
